import {checkExists} from 'external/dev_april_corgi+/js/common/asserts';

import {DataValue} from '../types/data';

import {PipeId} from './graph';
import {
  Instruction,
  LoadLabwareInstruction,
  LoadMaterialInstruction,
  StoreMaterialInstruction,
  getSimulationScript,
} from './opentrons';
import {OpentronsExecutor} from './opentrons_actions_handler';

export class OpentronsSimulatingExecutor implements OpentronsExecutor {
  private readonly pending: Array<{
    pipe: PipeId;
    instructions: Instruction[];
  }>;
  private script: string | undefined;

  constructor(
    private readonly name: string,
    private readonly authorName: string,
    private readonly robotName: string,
  ) {
    this.pending = [];
    this.script = undefined;
  }

  getScript(): string {
    return checkExists(this.script);
  }

  async create(): Promise<void> {}

  async setup(
    pipe: PipeId,
    instruction:
      | LoadLabwareInstruction
      | LoadMaterialInstruction
      | StoreMaterialInstruction,
  ): Promise<void> {
    this.pending.push({pipe, instructions: [instruction]});
  }

  async execute(pipe: PipeId, instructions: Instruction[]): Promise<void> {
    this.pending.push({pipe, instructions});
  }

  async pipeFinished(
    pipe: PipeId,
    value: DataValue | undefined,
  ): Promise<void> {}

  async finish(): Promise<void> {
    this.script = getSimulationScript(
      this.name,
      this.pending,
      this.authorName,
      this.robotName,
    );
  }
}
